import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ActiveCartFacade, Cart } from '@spartacus/cart/base/root';
import { SavedCartFormDialogComponent } from '@spartacus/cart/saved-cart/components';
import { SavedCartFormType } from '@spartacus/cart/saved-cart/root';
import { GlobalMessageType } from '@spartacus/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-custom-cart-details-restore-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './custom-cart-details-restore-modal.component.html',
  styleUrl: './custom-cart-details-restore-modal.component.scss',
})
export class CustomCartDetailsRestoreModalComponent extends SavedCartFormDialogComponent {
  activeCartService = inject(ActiveCartFacade);
  currentCart$: Observable<Cart> = this.activeCartService.getActive();

  resetSavedCartStates2(): void {
    this.savedCartService.clearCloneSavedCart();
    this.savedCartService.clearSaveCart();
    this.savedCartService.clearRestoreSavedCart();
  }

  override onComplete(success: boolean): void {
    if (success) {
      switch (this.layoutOption) {
        case SavedCartFormType.DELETE: {
          this.routingService.go({ cxRoute: 'savedCarts' });
          this.globalMessageService.add(
            {
              key: 'savedCartDialog.deleteCartSuccess',
            },
            GlobalMessageType.MSG_TYPE_CONFIRMATION
          );
          this.close('Successfully deleted a saved cart');

          break;
        }

        case SavedCartFormType.SAVE: {
          this.close('Successfully saved cart');
          this.savedCartService.clearSaveCart();

          this.globalMessageService.add(
            {
              key: 'savedCartCartPage.messages.cartSaved',
              params: {
                cartName: this.form.get('name')?.value || this.cart?.code,
              },
            },
            GlobalMessageType.MSG_TYPE_CONFIRMATION
          );

          break;
        }

        case SavedCartFormType.EDIT: {
          this.close('Successfully edited saved cart');
          this.savedCartService.clearSaveCart();
          this.globalMessageService.add(
            {
              key: 'savedCartDialog.editCartSuccess',
              params: {
                cartName: this.form.get('name')?.value || this.cart?.code,
              },
            },

            GlobalMessageType.MSG_TYPE_CONFIRMATION
          );

          break;
        }

        case SavedCartFormType.RESTORE: {
          this.close('Successfully restored saved cart');
          this.routingService.go({ cxRoute: 'cart' });
          this.globalMessageService.add(
            {
              key: 'savedCartDialog.restoreSavedCart',
              params: {
                cartName: this.form.get('name')?.value || this.cart?.code,
              },
            },
            GlobalMessageType.MSG_TYPE_CONFIRMATION
          );
          this.resetSavedCartStates2();
          break;
        }
      }
    }
  }

  override restoreSavedCart(cartId: string): void {
    if (this.isCloneSavedCart) {
      this.savedCartService.cloneSavedCart(
        cartId,
        this.form.get('cloneName')?.value
      );
    } else {
      this.savedCartService.restoreSavedCart(cartId);
    }
  }

  customToggleIsCloneSavedCart(){
    this.form.get('isCloneSavedCart')?.setValue(!this.form.get('isCloneSavedCart')?.value);
    super.toggleIsCloneSavedCart();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.form.addControl('preventSaveActiveCart', new FormControl(false));
    this.form.get('isCloneSavedCart')?.setValue(true);
    this.isCloneSavedCart = true;

    this.form.get('preventSaveActiveCart')?.valueChanges.subscribe((value) => {
      if (value) {
        this.form.get('cloneName')?.disable();
      } else {
        this.form.get('cloneName')?.enable();
      }
    });

    this.form.get('cloneName').setValue(this.cart?.code);

    this.form.get('cloneName')?.valueChanges.subscribe((value) => {
      this.form.get('name')?.setValue(`Copia de ${value}`);
    })
  }
}
